import React, { useState } from "react";
import MightyInput from "mighty-input";

import "./style.css";

export function AcceptInput({ value, accept, ...props }) {
  const render = next => {
    const out = Array.from(next);

    for (let i = 0; i < out.length; i++) {
      const char = out[i];

      if (!accept.test(char)) {
        out[i] = (
          <span className="highlightError-error" key={i}>
            {char}
          </span>
        );
      }
    }

    return out;
  };

  return <MightyInput value={value} render={render} {...props} />;
}
